import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable, xcss } from '@atlaskit/primitives';

import { stringLimiter } from '../../../../utils/string-limiter';

const DROPDOWN_LABEL_LIMIT = 20;

const messages = defineMessages({
	showDetails: {
		defaultMessage: 'SHOW DETAILS',
		description: 'the default title of the select list dropdown label',
		id: 'selectList.card.cardDropdown.showDetails',
	},
	expand: {
		defaultMessage:
			'Expand {contentExpandableLabel, select, undefined {DETAILS} other {{contentExpandableLabel}}}',
		description:
			'The accessible label for the expand dropdown icon, will use the contentExpandableLabel if it is provided',
		id: 'selectList.card.cardDropdown.expand',
	},
	collapse: {
		defaultMessage:
			'Collapse {contentExpandableLabel, select, undefined {DETAILS} other {{contentExpandableLabel}}}',
		description:
			'The accessible label for the collapse dropdown icon, will use the contentExpandableLabel if it is provided',
		id: 'selectList.card.cardDropdown.collapse',
	},
});
const buttonStyles = xcss({
	font: 'font.body.small',
	fontWeight: 'font.weight.semibold',
	paddingInline: 'space.0',
	color: 'color.text.subtle',
	display: 'flex',
	alignItems: 'center',
	gap: 'space.050',
});

export interface ContentDropdownProps {
	contentExpandableLabel?: string;
	isExpanded: boolean;
	onClick?(): void;
	testId: string;
}

export const ContentDropdown = (props: ContentDropdownProps): React.JSX.Element => {
	const intl = useIntl();
	const { testId, isExpanded, onClick, contentExpandableLabel } = props;

	return (
		<Pressable
			onClick={onClick}
			testId={`${testId}-show-expanded-card`}
			backgroundColor="elevation.surface.overlay"
			xcss={buttonStyles}
			aria-expanded={isExpanded}
		>
			{stringLimiter(DROPDOWN_LABEL_LIMIT, contentExpandableLabel).value ||
				intl.formatMessage(messages.showDetails)}
			{isExpanded ? (
				<ChevronUpIcon
					color="currentColor"
					spacing="spacious"
					label={intl.formatMessage(messages.collapse, { contentExpandableLabel })}
					size="small"
				/>
			) : (
				<ChevronDownIcon
					color="currentColor"
					spacing="spacious"
					label={intl.formatMessage(messages.expand, { contentExpandableLabel })}
					size="small"
				/>
			)}
		</Pressable>
	);
};
